// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component } from "react";

import { PageHeader, PageContent } from "components/layout";
import { trans } from "src/translations";

import { AdminPlansData } from "./AdminPlansData";

export class AdminPlans extends Component {
  render() {
    return (
      <div>
        <PageHeader>{trans.DISTR_ADMIN_PLANS__PAGE_HEADER()}</PageHeader>
        <PageContent>
          <AdminPlansData />
        </PageContent>
      </div>
    );
  }
}
